import clsx from 'clsx'
import { Dropdown, DropdownItem, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'components/Filters/FilterPanel/subcomponents/Dropdown/Dropdown.module.scss'
import FilterComponents from 'components/Filters/FilterPanel/subcomponents'

const FilterDropdown = ({
  filterManager,
  dropdownFilters = [],
  dropdownClassName = '',
  nestedDropdownClassName = '',
}) => {
  const { t } = useTranslation()
  const [visibleFilter, setVisibleFilter] = useState(null)

  const { updateFilter, filters, initial } = filterManager

  const showFilter = useCallback(
    (value) => {
      if (visibleFilter !== value) {
        setVisibleFilter(value)
      }
    },
    [visibleFilter, setVisibleFilter],
  )

  return (
    <>
      <Dropdown className={clsx(styles['dropdown'], dropdownClassName)}>
        {dropdownFilters.map((filter) => {
          return (
            <div
              key={'filter-row' + filter.key}
              className={clsx(styles['dropdown-node'], {
                [styles['dropdown-node_opened']]: visibleFilter === filter.key,
              })}
            >
              <DropdownItem
                onMouseOver={() => showFilter(filter.key)}
                endIcon={
                  <Icon
                    name={'arrow1-right'}
                    size={'s'}
                    color={'Label-Fifth'}
                  />
                }
              >
                {t(filter.label)}
              </DropdownItem>
            </div>
          )
        })}
      </Dropdown>
      <Dropdown className={clsx(styles['dropdown'], dropdownClassName)}>
        {dropdownFilters.map((filter) => {
          if (visibleFilter !== filter.key) return null

          const El = FilterComponents[filter.type]

          return (
            <El
              key={'filter-dropdown' + filter.key}
              className={clsx(styles['dropdown'], nestedDropdownClassName, {
                [styles['dropdown_opened']]: visibleFilter === filter.key,
              })}
              {...filter}
              defaultValue={initial[filter.key]}
              value={filters[filter.key]}
              name={filter.key}
              filterManager={filterManager}
              onApply={(update) => {
                setVisibleFilter(null)
                updateFilter(update)
              }}
            />
          )
        })}
      </Dropdown>
    </>
  )
}

FilterDropdown.propTypes = {
  filterManager: PropTypes.object,
  dropdownFilters: PropTypes.array,
  title: PropTypes.string,
  dropdownClassName: PropTypes.string,
  nestedDropdownClassName: PropTypes.string,
}

export default FilterDropdown
